export default {
  props: {
    imageUrl: {
      default: '',
      type: String,
    },
    title: {
      default: '',
      type: String,
    },
    subTitle: {
      default: '',
      type: String,
    },
    describe: {
      default: '',
      type: String,
    },
    imageAlt: {
      default: '',
      type: String,
    },
  },
}
